module.exports = "query GetItems($search: String, $category: ID) {\n  items(search: $search, category: $category, limit: 20) {\n    ...ItemFragment\n  }\n}\n"